import React, { ReactNode, useCallback } from 'react';
import ColorGradient from 'spw-projects/colors/color-gradient';
import { Box } from '@mui/material';

type Props = {
  title?: ReactNode;
  gradientColors: string[];
  gradientColorIndex: number;
  subcategory: string;
  onSelectSubcategoryColor: (subcategory: string, colorIndex: number) => void;
};

const SubcategoryColorGradient = ({
  title,
  gradientColors,
  gradientColorIndex,
  subcategory,
  onSelectSubcategoryColor,
}: Props) => {
  const onSelectColor = useCallback(
    (colorIndex: number) => {
      onSelectSubcategoryColor(subcategory, colorIndex);
    },
    [subcategory, onSelectSubcategoryColor]
  );

  return (
    <Box mb={2}>
      {title}
      <ColorGradient
        gradientColors={gradientColors}
        gradientColorIndex={gradientColorIndex}
        onSelectColor={onSelectColor}
      />
    </Box>
  );
};

export default SubcategoryColorGradient;
